/* eslint-env browser */
import domready from 'domready';
import lastSearches from './index';

import './styles.css';

function ifId(id, fn) {
    const el = document.getElementById(id);
    if (el) {
        fn(el);
    }
}

domready(() => {
    ifId('last-searches', lastSearches);
});
